import useAppStore from "@/context/store";
import { getUdeskSign } from "@/services";

let isInitUdesk = false;
const initUdesk = async (user, callback) => {
  if (!isInitUdesk) {
    const code = "2fc6j4ag";
    const link =
      "https://ttxsapp.udesk.cn/im_client/?web_plugin_id=98162&language=zh-cn";
    const isLogin = user;
    const config = {
      code: code,
      link: link,
      mode: "newtab",
      mobile: {
        mode: "blank",
        noBubble: true,
      },
      panel: {
        css: {
          right: "20px",
        },
      },
      css: {
        width: "0px",
        height: "0px",
        overflow: "hidden",
      },
      language: "zh-cn",
      onReady: function () {
        callback?.();
      },
    };
    if (isLogin) {
      const name = user.username;
      const urlname = user.urlname;
      const webToken = user.user_id;

      const signData = await getUdeskSign();
      const nonce = signData.nonce;
      const timestamp = signData.timestamp;
      const signature = signData.signature;

      config.customer = {
        c_cf_entrance: "花瓣",
        "c_cf_web UID": webToken,
        c_cf_对话页面: window.location.href,
        c_cf_咨询信息: "用户个人主页：https://huaban.com/user/" + urlname,
        c_name: name,
        nonce,
        signature,
        timestamp,
        web_token: webToken,
      };
    }

    // 加载 udesk 脚本，因为 udesk 脚本是异步加载的，加载完成后会自动始化
    if (!window.ud) {
      (function (a, h, c, b, f, g) {
        a["UdeskApiObject"] = f;
        a[f] =
          a[f] ||
          function () {
            a[f].d = a[f].d || [];
            a[f].d.push(arguments);
          };
        g = h.createElement(c);
        g.async = 1;
        g.charset = "utf8";
        g.src = b;
        c = h.getElementsByTagName(c)[0];
        c.parentNode.insertBefore(g, c);
      })(
        window,
        document,
        "script",
        "//assetscli.udesk.cn/im_client/js/udeskApi.js",
        "ud"
      );
    }

    window.ud(config);
    isInitUdesk = true;
  } else {
    callback?.();
  }
};

export function openUdesk() {
  initUdesk(useAppStore.getState().user, () => {
    window.ud && window.ud.showPanel();
  });
}

typeof window !== "undefined" && (window.openUdesk = openUdesk);
